/**
 * BP-02:「视频脚本 → 数字人口播」生产端。
 *
 * 消费端(`presets.ts` 的 `dh_from_video` + `DigitalHumanCreatePage` 的预填与 sceneKey 打标)
 * 2026-07 就全套建好了,但**全仓没有一处 navigate 过去**,catalog 也没有这张卡 ——
 * 整条链路从来没被触发过。这里补的就是那一处调用的取数。
 *
 * 不需要新数据、不需要动契约:逐镜口播 `voiceovers` 视频详情页本来就有(并且已在逐镜卡里渲染)。
 */

/**
 * 逐镜口播 → 数字人创建页要的整段文案。
 *
 * 全空返回 `null` = **不给按钮**:纯画面片(无配音)送过去只会得到一个空脚本,
 * 那就是又一个"点了没用的按钮"(与 BP-04「空转」同型)。
 */
export function dhScriptFromVoiceovers(voiceovers: string[]): string | null {
  if (!Array.isArray(voiceovers)) return null;
  const lines = voiceovers.map((v) => (typeof v === "string" ? v.trim() : "")).filter(Boolean);
  return lines.length ? lines.join("\n") : null;
}
